import {
  PAYMENT_STATUS,
  TERMINAL_EVENT,
  TerminalEventMonitoring,
} from '@lightspeed-payments/payments-terminal-sdk'
import { isCancellation } from './errorChecking'
import { STRIPE_ERROR_CODE, TRANSACTION_TYPE } from './lspayConstants'

export const trackTerminalCompleteWithError = (
  terminalMonitoringInstance: TerminalEventMonitoring,
  error: any,
  isRefund = false
) => {
  const transactionType = isRefund
    ? TRANSACTION_TYPE.REFUND
    : TRANSACTION_TYPE.PAYMENT
  if (isCancellation(error)) {
    terminalMonitoringInstance.sendEvent(TERMINAL_EVENT.COMPLETE, {
      payment: {
        status: PAYMENT_STATUS.CANCELLED,
      },
      transactionType,
    })
    return
  }
  if (
    error?.code === STRIPE_ERROR_CODE.DECLINED ||
    error?.code === STRIPE_ERROR_CODE.EXPIRED
  ) {
    terminalMonitoringInstance.sendEvent(TERMINAL_EVENT.COMPLETE, {
      payment: {
        status: PAYMENT_STATUS.DECLINED,
      },
      transactionType,
    })
    return
  }
  terminalMonitoringInstance.sendEvent(TERMINAL_EVENT.COMPLETE, {
    payment: {
      status: PAYMENT_STATUS.ERROR,
    },
    error: {
      code: error?.code,
      message: error?.message || 'Unknown error',
    },
    transactionType,
  })
}
